import React from "react"
import { Badge, Button } from "reactstrap"

export const CustomerHeader = ({
  handleAddNewClick,
  handleRefresh,
  resetParams,
  isRefetching,
  hasActiveFilters,
  total,
}) => {
  return (
    <div className="d-flex flex-wrap align-items-center gap-2 mt-3">
      <h5 className="mb-0 card-title flex-grow-1">
        Total <Badge className="badge-soft-info">{total ?? 0}</Badge>
      </h5>
      <div className="d-flex flex-wrap gap-1">
        <Button color="primary" onClick={handleAddNewClick}>
          Add New
        </Button>
        <Button color="light" onClick={handleRefresh}>
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>
        {hasActiveFilters && (
          <Button color="danger" onClick={resetParams}>
            Reset Filters
          </Button>
        )}
      </div>
    </div>
  )
}
